export default {
  namespaced: true,
  state: {
    // 活动编码 - 客户导入需要
    activityCode: '',
    // 对应销售数据
    salerData: {},
    // 活动分类code: 费用归属里字段依赖于这个
    activityClassification: '',
    // 活动分类是否为初始化数据: 不标识的话，费用归属会有影响
    activityClassificationLoadFlag: 0,
    // 是否是联合市场活动: 费用归属里有判断
    isUnionMarket: 0,
    // 1-可编辑全部  2-可编辑基本信息活动信息  3-可编辑费用归属
    editFlag: 0,
    // 对应销售是否为初始化时数据: 不标识的话，费用归属会有影响
    salerLoadFlag: 0,
    // 是否需要活动组支持: 费用归属组件是否显示依赖于该字段
    needOrganizer: 0
  },
  mutations: {
    setNeedOrganizer (state, data) {
      state.needOrganizer = data;
    },
    setActivityClassificationLoadFlag (state, data) {
      state.activityClassificationLoadFlag = data;
    },
    setActivityClassification (state, data) {
      state.activityClassification = data;
    },
    setIsUnionMarket (state, data) {
      state.isUnionMarket = data;
    },
    setSalerLoadFlag (state, data) {
      state.salerLoadFlag = data;
    },
    setEditFlag (state, data) {
      state.editFlag = data;
    },
    setActivityCode (state, data) {
      state.activityCode = data;
    },
    setSalerData (state, data) {
      state.salerData = data;
    }
  },
  actions: {

  },
  getters: {

  }
};
